// import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import authReducer from "./slices/auth/authSlice";
// import adminBackgroundReducer from "./slices/adminBackgroundSlice/adminBackgroundSlice";
// import paymentSourceTypeReducer from "./slices/paymentSourceType/paymentSourceTypeSlice";
// import myStripePaymentReducer from "./slices/myStripePayment/myStripePaymentSlice";
// import planTypeReducer from "./slices/planType/planTypeSlice";
// import { encryptTransform } from "redux-persist-transform-encrypt";
// import {
//   persistStore,
//   persistReducer,
//   FLUSH,
//   REHYDRATE,
//   PAUSE,
//   PERSIST,
//   PURGE,
//   REGISTER,
// } from "redux-persist";
// import storage from "redux-persist/lib/storage";

// // Combine all reducers
// const rootReducer = combineReducers({
//   auth: authReducer,
//   adminBackground: adminBackgroundReducer,
//   planType: planTypeReducer,
//   paymentSource: paymentSourceTypeReducer,
//   myStripePayment: myStripePaymentReducer,
// }) as unknown as typeof rootReducer;

// const encryptor = encryptTransform({
//   secretKey: import.meta.env.VITE_STORAGE_ENCRYPTION_SECRET, // use env variable!
//   onError: (error) => {
//     console.error("Encryption error:", error);
//   },
// });

// // Persist configuration
// const persistConfig = {
//   key: "root",
//   version: 1,
//   storage,
//   transforms: [encryptor], // 🔐 This encrypts/decrypts automatically
// };
// // create persisted reducer
// const persistedReducer = persistReducer(persistConfig, rootReducer);
// // Configure store
// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//       },
//     }),
// });

// // create persistor
// export const persistor = persistStore(store);

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/auth/authSlice";
import adminBackgroundReducer from "./slices/adminBackgroundSlice/adminBackgroundSlice";
import paymentSourceTypeReducer from "./slices/paymentSourceType/paymentSourceTypeSlice";
import myStripePaymentReducer from "./slices/myStripePayment/myStripePaymentSlice";
import planTypeReducer from "./slices/planType/planTypeSlice";
import onchainDepositReducer from "./slices/elanPay/onChainDepositSlice"; // NEW
import { encryptTransform } from "redux-persist-transform-encrypt";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  adminBackground: adminBackgroundReducer,
  planType: planTypeReducer,
  paymentSource: paymentSourceTypeReducer,
  myStripePayment: myStripePaymentReducer,
  onchainDeposit: onchainDepositReducer, // NEW — persisted automatically (no whitelist)
}) as unknown as typeof rootReducer;

const encryptor = encryptTransform({
  secretKey: import.meta.env.VITE_STORAGE_ENCRYPTION_SECRET,
  onError: (error) => {
    console.error("Encryption error:", error);
  },
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  transforms: [encryptor], // 🔐 encrypts/decrypts automatically
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
